import { useEffect, useRef } from "react";
import * as Sentry from "@sentry/react";

const safeWindow = typeof window !== "undefined" ? window : undefined;

const sanitize = (value) => {
  try {
    return JSON.parse(JSON.stringify(value));
  } catch (error) {
    console.warn("Sentry context sanitization failed", error);
    return undefined;
  }
};

export const storeContextSnapshot = (name, value) => {
  const snapshot = sanitize(value);
  if (!snapshot) return;

  if (Sentry.getCurrentHub().getClient()) {
    Sentry.setContext(name, snapshot);
  }

  if (safeWindow) {
    safeWindow.__SENTRY_CONTEXTS__ = {
      ...(safeWindow.__SENTRY_CONTEXTS__ || {}),
      [name]: snapshot,
    };
  }
};

export const attachStoredContexts = (event) => {
  if (safeWindow && safeWindow.__SENTRY_CONTEXTS__) {
    event.contexts = {
      ...(event.contexts || {}),
      ...safeWindow.__SENTRY_CONTEXTS__,
    };
  }
  return event;
};

const useSentryContext = (name, value) => {
  const lastSnapshot = useRef();

  useEffect(() => {
    const snapshot = sanitize(value);
    if (!snapshot) return;

    const snapshotKey = JSON.stringify(snapshot);
    if (snapshotKey === lastSnapshot.current) return;
    lastSnapshot.current = snapshotKey;
    storeContextSnapshot(name, snapshot);
  }, [name, value]);
};

export default useSentryContext;

